import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sunIcon", "moonIcon"];
  static values = { mode: String };

  connect() {
    // Keep an explicit choice, otherwise respect the operating-system preference.
    const savedMode = localStorage.getItem("theme") || this.preferredMode;

    // Apply the theme
    this.applyTheme(savedMode);
  }

  toggle(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Check the actual current state from the HTML element
    const isDark = document.documentElement.classList.contains("dark");
    const newMode = isDark ? "light" : "dark";

    // Apply the new theme
    this.applyTheme(newMode);
  }

  applyTheme(mode) {
    // Save to localStorage
    localStorage.setItem("theme", mode);

    // Update the HTML element class - this is what Tailwind uses for dark mode
    if (mode === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    // Update icons
    this.updateIcons(mode);
  }

  get preferredMode() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }

  updateIcons(mode) {
    if (!this.hasSunIconTarget || !this.hasMoonIconTarget) {
      // Icons not available on this page, skip update
      return;
    }

    if (mode === "dark") {
      // Dark mode: show sun icon (to switch to light), hide moon icon
      this.sunIconTarget.classList.remove("hidden");
      this.moonIconTarget.classList.add("hidden");
    } else {
      // Light mode: hide sun icon, show moon icon (to switch to dark)
      this.sunIconTarget.classList.add("hidden");
      this.moonIconTarget.classList.remove("hidden");
    }
  }
}
